// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Card_4_wrapper__ut9FI"};